import { Box, Card, CardContent, Typography, Chip } from "@mui/material";
import styles from "./ExamsCalendar.module.css";

interface YearCalendarProps {
  events: any[];
  currentDate: Date;
  onMonthSelect: (date: Date) => void;
  selectedWorkPointId: string;
}

function YearCalendar({ events, currentDate, onMonthSelect, selectedWorkPointId }: YearCalendarProps) {
  const currentYear = currentDate.getFullYear();
  
  // Create array of months for the current year
  const months = Array.from({ length: 12 }, (_, index) => {
    const monthDate = new Date(currentYear, index, 1);
    return {
      date: monthDate,
      name: monthDate.toLocaleDateString("ro-RO", { month: "long" }),
      index,
    };
  });

  // Get events for a specific month
  const getEventsForMonth = (monthIndex: number) => {
    return events.filter((event) => {
      const eventDate = new Date(event.start);
      return eventDate.getFullYear() === currentYear && eventDate.getMonth() === monthIndex;
    });
  };

  // Get unique event types for a month
  const getEventTypesForMonth = (monthIndex: number) => {
    const monthEvents = getEventsForMonth(monthIndex);
    const typesSet = new Set(monthEvents.map((event) => event.type || "Examen"));
    const types = Array.from(typesSet);
    return types;
  };

  const handleMonthClick = (monthDate: Date) => {
    onMonthSelect(monthDate);
  };

  return (
    <Box className={styles.yearView}>
      <Box className={styles.monthsGrid}>
        {months.map((month) => {
          const monthEvents = getEventsForMonth(month.index);
          const eventTypes = getEventTypesForMonth(month.index);
          
          return (
            <Card
              key={month.index}
              className={styles.monthCard}
              onClick={() => handleMonthClick(month.date)}
            >
              <CardContent className={styles.monthCardContent}>
                <Typography variant="h6" className={styles.monthName}>
                  {month.name}
                </Typography>
                
                <Typography variant="body2" className={styles.monthEventCount}>
                  {monthEvents.length === 0
                    ? "Fără examene"
                    : `${monthEvents.length} ${monthEvents.length === 1 ? "examen" : "examene"}`}
                </Typography>
                
                {eventTypes.length > 0 && (
                  <Box className={styles.monthEventTypes}>
                    {eventTypes.map((type, index) => (
                      <Chip
                        key={index}
                        label={type}
                        size="small"
                        className={styles.chipSmall}
                      />
                    ))}
                  </Box>
                )}
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
}

export default YearCalendar;